import React, { Component, Fragment } from 'react';
import SVGInline from "react-svg-inline";
import injectSheet from 'react-jss';
import iconBack from '../../integrationMarketplace/assets/images/back.svg';
import { ElemBack, styleBack } from '../../integrationMarketplace/styles/slack.style';
import { Typography, theme } from '@hiver/hiver-ui-kit';


class Header extends Component {
  
    render() {
        const {
            imageClickable,
            imageClickableSm,
            imageNotClickableSm,
            imageNotClickable,
            appTitlebarMargin,
        } = this.props.classes;

        const {
            borderBottom,
            image,
            headLine,
            headLineSubText,
            imageWidth,
            smSubsection,
            headingClass,
            className,
            svgClass,
            isMarketplaceItem,
        } = this.props;

        let {onImageClick} = this.props;

        let imageClass="";
        let titlebarMargin = "";
        if (onImageClick) {
            imageClass = imageClickable;
            if (smSubsection) {
                imageClass = imageClickableSm;
            }
        }else{
            onImageClick = () => {}
            imageClass = imageNotClickable;
            if (smSubsection) {
                imageClass = imageNotClickableSm;
                titlebarMargin = appTitlebarMargin;
            }
        }

        const width = imageWidth ? imageWidth : "20";
        const borderBottomClass = borderBottom ? borderBottom : '';

        return (
            <div className={borderBottomClass + titlebarMargin + ` h-app-titlebar ${className}`}>
                <div className='h-header-text-cont h-section-header'>
                    {isMarketplaceItem && (
                        <Fragment>
                            <SVGInline
                                height="20px"
                                width="20px"
                                svg={iconBack}
                                style={styleBack}
                                onClick={this.props.onBackClicked}
                            />
                            <ElemBack>Back</ElemBack>
                        </Fragment>
                    )}
                    { image && <SVGInline
                        width={width + "px"}
                        svg={image}
                        onClick={onImageClick}
                        className={`${imageClass} ${svgClass}`}
                    />
                    }
                    {!isMarketplaceItem && (
                        <div className={`h-h1 ${headingClass}`}>
                            <Typography variant="h2" color={theme.palette.gray.black}>
                              {headLine}
                            </Typography>
                           {headLineSubText && <Typography variant="body2" color={theme.palette.gray.gray3}>
                              {headLineSubText}
                            </Typography>}
                        </div>
                    )}
                </div>
                <div>
                    {this.props.children}
                </div>
            </div>
        );
    }
}


const Styles = {
    headerContainer: {
        paddingBottom: "10px"
    },
    imageContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    imageClickable: {
        cursor: "pointer",
        width: "46px",
        display: "flex",
        justifyContent: "center",
        paddingBottom : "2px"
    },
    imageClickableSm : {
        cursor: "pointer",
        width: "30px",
        display: "flex",
        justifyContent: "flex-start",
        paddingBottom : "2px",
        marginLeft: "30px"
    },
    imageNotClickableSm : {
        width: "30px",
        justifyContent: "flex-start",
        display: "none",
        paddingBottom : "2px",
    },
    imageNotClickable : {
        width: "30px",
        justifyContent: "flex-start",
        paddingBottom : "2px",
    },
    appTitlebarMargin : {
        marginLeft : "30px"
    }
};

export default injectSheet(Styles)(Header);
